<template lang="pug">
  el-dialog(title="查看详情", :close-on-click-modal='false', :visible.sync='visible' :modal-append-to-body='false')
    el-form(:model='dataForm', :rules='dataRule', ref='dataForm',label-suffix=":"  label-width='80px')
      el-form-item(label='场馆名称', prop='name')
        <span>{{dataForm.name}}</span>
      el-form-item(label='站点', prop='area')
        <span>{{dataForm.area}}</span>
      el-form-item(label='地区')
        <span>{{addressName}}</span>
      el-form-item(label='场馆地址', prop='address')
        <span>{{dataForm.address}}</span>
      el-form-item(label='主办方')
        <span>{{dataForm.orgName}}</span>
      el-form-item(label='联系电话', prop='tel')
        <span>{{dataForm.tel}}</span>
      el-form-item(label='场馆介绍', prop='detail')
        <div v-html="dataForm.detail" ></div>
    span.dialog-footer(slot='footer')
      el-button(@click='visible = false') 取消
</template>

<script>
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: 0,
        name: '',
        area: '',
        address: '',
        tel: '',
        detail: '',
        proviceName: '',
        cityNames: '',
        orgName: ''
      }
    }
  },
  computed: {
    addressName: function() {
      if(this.dataForm.proviceName==this.dataForm.cityNames){
        return this.dataForm.proviceName
      }else{
        return this.dataForm.proviceName + '' + this.dataForm.cityNames
      }
    }
  },
  methods: {
    init1 (id) {
      this.dataForm.id = id || 0
      this.visible = true
          this.$http({
            url: this.$http.adornUrl(`/pbPlaces/getId/${this.dataForm.id}`),
            method: 'get',
            params: this.$http.adornParams()
          }).then((data) => {
            if (data && data.code === 0) {
              this.dataForm.name = data.bean.name
              this.dataForm.area = data.bean.area
              this.dataForm.proviceName = data.bean.proviceName
              this.dataForm.cityNames = data.bean.cityNames
              this.dataForm.address = data.bean.address
              this.dataForm.orgName = data.bean.orgName
              this.dataForm.tel = data.bean.tel
              this.dataForm.detail = data.bean.detail
          }
        })
      }
   }
 }
</script>
<style >
  pre{
white-space: pre-wrap;           /* css-3 */
white-space: -moz-pre-wrap;      /* Mozilla, since 1999 */
white-space: -pre-wrap;          /* Opera 4-6 */
white-space: -o-pre-wrap;        /* Opera 7 */
word-wrap: break-word;           /* Internet Explorer 5.5+ */
}
*{
  margin:0px;
}
</style>